export default {
	cameraMode: false,
	userUsesCamara: true, // Usuario ocupa camara (VS selector de archivos en sistema)
};